import { render, staticRenderFns } from "./device.view.vue?vue&type=template&id=53596aff&"
import script from "./device.view.vue?vue&type=script&lang=js&"
export * from "./device.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports